import Form from '.';
import useStore from '../Hooks/useStore';
import useWindowDimensions from '../Hooks/useWindowDimensions';
import React, { useEffect, useRef, useState } from 'react';

export default function FormPriceSearch() {
  const [getters, setters] = useStore();
  const { height: screenHeight } = useWindowDimensions();

  const {
    product: { getProduct },
    user: { getUser },
  } = getters;

  const {
    product: { setProduct, findProductsByFilter },
  } = setters;
  const [currentPage, setCurrentPage] = useState(1);
  const [numberOfLines, setNumberOfLines] = useState(
    screenHeight > 875 ? 3 : 2,
  );
  const [numberOfColumns, setNumberOfColumns] = useState(5);
  let timerId: NodeJS.Timeout;
  useEffect(() => {
    clearTimeout(timerId);
    let calculatedNumberOfLines = 2;
    if (screenHeight > 875) {
      calculatedNumberOfLines = 3;
    }
    if (screenHeight <= 875) {
      calculatedNumberOfLines = 2;
    }
    setNumberOfLines(calculatedNumberOfLines);
    timerId = setTimeout(() => {
      filterProducts(1, calculatedNumberOfLines * numberOfColumns);
    }, 500);
    return () => {
      clearTimeout(timerId);
    };
  }, [screenHeight]);

  const gap = 20;
  const { lastPage: numberOfPages } = getProduct('filtered.price.meta');
  const [pageNumbers, setPageNumbers] = useState<Array<string | number>>([]);
  const [loading, setLoading] = useState(false);
  const filterProducts = (
    page = currentPage,
    limit = numberOfColumns * numberOfLines,
  ) =>
    new Promise(() => {
      setLoading(true);
      findProductsByFilter('price', page, limit)
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    });

  const onChange = (e: any) => {
    setProduct({
      field: 'filter.price',
      value: e.target.value,
    });
    setCurrentPage(1);
    filterProducts(1, numberOfColumns * numberOfLines);
  };

  const filialId = getUser('selectedFilialId');

  React.useEffect(() => {
    filterProducts(currentPage, numberOfColumns * numberOfLines);
  }, [filialId]);

  const conc = (str: string, n: number) =>
    n > 0 ? Array.from({ length: n }, () => str).join(' ') : '';

  const cardWidth = `calc((80vw - 4rem - ${
    numberOfColumns - 1
  } * ${gap}px) / ${numberOfColumns})`;

  const visiblePages = 5;
  const defaultPages = 2;
  const maxPageNumber = visiblePages + 2 * defaultPages;
  useEffect(() => {
    if (numberOfPages > maxPageNumber) {
      let leftPages = 0;
      let rightPages = 0;
      if (numberOfPages <= visiblePages) {
        leftPages = 0;
        rightPages = numberOfPages - 1;
      } else {
        leftPages = Math.min(
          currentPage - 1,
          Math.floor((visiblePages - 1) / 2),
        );
        rightPages = Math.min(
          numberOfPages - currentPage,
          Math.floor((visiblePages - 1) / 2),
        );
        if (currentPage - leftPages <= 1) {
          rightPages += leftPages + 1 - currentPage;
          leftPages = currentPage - 1;
        } else if (numberOfPages - currentPage <= rightPages) {
          leftPages += rightPages - (numberOfPages - currentPage);
          rightPages = numberOfPages - currentPage;
        }
        if (currentPage + rightPages === numberOfPages) {
          leftPages = Math.max(leftPages, visiblePages - rightPages - 1);
        }
      }
      const startPage = Math.max(1, currentPage - leftPages);
      const endPage = Math.min(numberOfPages, startPage + visiblePages - 1);
      const pageNumbers: any = [];
      for (let i = 1; i <= numberOfPages; i++) {
        if (
          i <= 2 ||
          i >= numberOfPages - 1 ||
          (i >= startPage && i <= endPage)
        ) {
          pageNumbers.push(i);
        } else if (i === defaultPages + 1 && startPage > defaultPages + 1) {
          pageNumbers.push('...');
        } else if (
          i === numberOfPages - defaultPages &&
          endPage < numberOfPages - defaultPages
        ) {
          pageNumbers.push('...');
        }
      }
      setPageNumbers(pageNumbers);
    } else {
      setPageNumbers(
        Array.from({ length: numberOfPages }).map((_, i) => i + 1),
      );
    }
  }, [currentPage, numberOfPages]);

  return (
    <Form
      style={{
        gridTemplate: `'${conc('input', numberOfColumns - 2)} ${conc(
          'filter',
          2,
        )}' / ${conc(cardWidth, numberOfColumns)}`,
        gap: gap,
        marginBottom: gap,
      }}
      onSubmit={(e: any) => {
        e.preventDefault();
      }}
    >
      <Form.Input.Search
        value={getProduct('filter.price')}
        onDebouncedChange={onChange}
        lineLabel="Pesquise o produto"
        fontColor={'rgb(5, 5, 5)'}
        label="Pesquisar produto"
        fontSize={16}
        activeLabelColor="white"
        loading={loading}
        performAction={filterProducts}
      />
    </Form>
  );
}
